import React, {useEffect, useState} from "react";

import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {css} from "@emotion/css";
import {UserService} from "../../serverService/userService/UserService";
import {useNavigate} from "react-router-dom";
import {useDebounce} from "@uidotdev/usehooks";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoChipTypes,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMobileInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showErrorMessage,
    RaikoTableTitleContainer
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function UsersList() {


    let page = 0
    const size = 20

    const [isLoading, setIsLoading] = useState(false)
    const [usersListData, setUsersListData] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState("");
    const [fullName, setFullName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");


    const fullNameFilter = useDebounce(fullName, 500);
    const phoneNumberFilter = useDebounce(phoneNumber, 500);


    const service = new UserService()
    useEffect(() => {
        if (typeof service !== 'undefined') {
            getUsersListFromServer()
        }
    }, [
        fullNameFilter,
        phoneNumberFilter,
    ])


    function preparationRowsUsersTable(id, number, fullName, phoneNumber, nationalCode, signupAt, enabled) {
        return {
            id: id,
            number: number,
            fullName: fullName ? fullName : "-",
            phoneNumber: phoneNumber,
            nationalCode: nationalCode,
            signupAt: convertUniversalDateTimeToPersianDateTime(signupAt),
            enabled: enabled ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }
    }

    function getUsersListFromServer() {
        setIsLoading(true)
        service.getUsersList(
            page,
            size,
            fullNameFilter,
            phoneNumberFilter
        ).then(
            response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setUsersListData([])
                response.data.map((item, index) => {
                    setUsersListData(prevState => [
                        ...prevState,
                        preparationRowsUsersTable(
                            item.id,
                            (page * size) + index + 1,
                            item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : "-",
                            item.phoneNumber,
                            item.nationalCode,
                            item.signupAt,
                            item.enabled
                        )
                    ])
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getUsersListFromServer()
    }

    const navigate = useNavigate()

    function showUserInformation(id) {
        let fullName = ""
        usersListData.map((item) => {
            if (item.id === id) {
                fullName = item.fullName
            }
        })
        navigate(RouteHelper.UserInformation.globalUrl.replace(":id", id),
            {state: {fullName: fullName}, replace: false}
        )

    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.UsersList.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.UsersList.name,
                            ""
                        ),
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جستجو"}
                            subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                        >
                            <RaikoGridTwoColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام و نام خانوادگی"}
                                    setValue={setFullName}
                                    value={fullName}/>
                                <RaikoMobileInputOutlined
                                    labelText={"شماره همراه"}
                                    setValue={setPhoneNumber}
                                    value={phoneNumber}/>
                            </RaikoGridTwoColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"کاربران"}
                                amount={numberOfItems}
                            />
                            <RaikoCustomTable
                                isLoading={isLoading}
                                data={usersListData}
                                header={usersTableHeader}
                                rowClicked={showUserInformation}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePagination}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

const usersTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "fullName",
        label: "نام و نام خانوادگی"
    },
    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "nationalCode",
        label: "کد ملی",
    },
    {
        id: "signupAt",
        label: "تاریخ ثبت نام"
    },
    {
        id: "enabled",
        label: "وضعیت"
    },
]